import * as am4charts from '@amcharts/amcharts4/charts';
import * as am4core from '@amcharts/amcharts4/core';
import clsx from 'clsx';
import React, { useEffect, useLayoutEffect } from 'react';
import { useState } from 'react';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';

import useCustomerAccountFeatures from 'src/hooks/useCustomerAccountFeatures';

import apiService from '../../../services/api.service';
import { lightTheme } from '../../../themes/lightTheme';
import Card from '../../Card/Card.js';
import CardBody from '../../Card/CardBody';
import CardHeader from '../../Card/CardHeader.js';
import ContentFont from '../../Typography/ContentFont';
import ChartLogo from '../../parts/ChartLogo';
import ChartNoData from '../../parts/ChartNoData.js';
import LoadingOverlay from '../../parts/LoadingOverlay.js';

const useStyles = makeStyles((theme) => ({
  chart: {
    height: 300,
    paddingTop: 40,
  },
  chartTitle: {
    height: 125,
  },
}));

function FreightSpendsPieChart(props) {
  const classes = useStyles();
  const [chartDataInput, setChartDataInput] = useState([]);
  const { FilterComponentData, baseQueryString } = props;
  const [showNoData, setShowNoData] = useState(false);
  const history = useHistory();
  const [IsLoading, setIsLoading] = useState();
  const { enabledConsolidatedShipmentsSpendsFeature, enabledShipmentSpendsFeature } = useCustomerAccountFeatures();

  function getDetailsPageUrl() {
    if (enabledConsolidatedShipmentsSpendsFeature) {
      return '/consolidated-shipments-spends?' + baseQueryString;
    } else if (enabledShipmentSpendsFeature) {
      return '/shipment-spends?' + baseQueryString;
    }
    return '';
  }

  useEffect(() => {
    let isCancelled = false;
    if (FilterComponentData.accountId && FilterComponentData.start && FilterComponentData.end) {
      setIsLoading(true);
      apiService
        .getFreightSpendsReport(
          FilterComponentData.accountId,
          FilterComponentData.dateBasedOn,
          FilterComponentData.start,
          FilterComponentData.end,
          FilterComponentData.suppliers
        )
        .then((result) => {
          if (!isCancelled) {
            if (result.data && result.data.items && result.data.items.length > 0) {
              setShowNoData(false);
              setChartDataInput(result.data);
            } else {
              setShowNoData(true);
              setChartDataInput([]);
            }
            setIsLoading(false);
          }
        })
        .catch((err) => {
          if (err.response && err.response.status === 401) history.push('/login');
        });
    }

    return () => {
      isCancelled = true;
    };
  }, [FilterComponentData, history]);

  useLayoutEffect(() => {
    var chart;

    function hasChartData() {
      if (chartDataInput && chartDataInput.items && chartDataInput.items.length > 0) {
        return true;
      } else {
        return false;
      }
    }

    if (hasChartData()) {
      var colorList = [];
      for (var i = 0; i < lightTheme.chart.colors.length; i++) {
        colorList.push(am4core.color(lightTheme.chart.colors[i]));
      }

      chart = am4core.create('FreightSpendingPieChart', am4charts.PieChart);
      chart.logo.disabled = true;
      // chart.data = prepareStuff(chartDataInput);
      chart.data = chartDataInput.items;

      // Add label
      chart.innerRadius = 50;
      chart.radius = 100;
      let label = chart.seriesContainer.createChild(am4core.Label);

      label.horizontalCenter = 'middle';
      label.verticalCenter = 'middle';
      label.fontSize = 11;

      // Add and configure Series
      let pieSeries = chart.series.push(new am4charts.PieSeries());
      pieSeries.colors.list = colorList;
      pieSeries.slices.template.stroke = am4core.color('#fff');
      pieSeries.dataFields.value = 'value';
      pieSeries.dataFields.category = 'name';
      pieSeries.slices.template.tooltipText = "{name}: {value.percent.formatNumber('#.#')}% (${value.formatNumber('#,###.#')})";
      pieSeries.fontSize = 11;
      pieSeries.alignLabels = false;
      pieSeries.labels.template.bent = true;
      pieSeries.labels.template.radius = 3;
      pieSeries.labels.template.padding(0, 0, 0, 0);

      pieSeries.ticks.template.disabled = true;
    }

    return () => {
      if (chart) chart.dispose();
    };
  }, [chartDataInput, showNoData]);

  return (
    <Card chart>
      <LoadingOverlay IsLoading={IsLoading} />
      <CardHeader className={'dashboard-chart-area'}>
        <ContentFont>
          {showNoData ? <ChartNoData text={'No Supplier Specific Data for This Chart'} /> : <div id="FreightSpendingPieChart" className={classes.chart}></div>}
        </ContentFont>
      </CardHeader>
      <CardBody className={clsx(classes.chartTitle, 'dashboard-chart-title-area')}>
        <Link to={getDetailsPageUrl()}>
          <h4>Freight Spending</h4>
        </Link>
        <ChartLogo />
      </CardBody>
    </Card>
  );
}

export default FreightSpendsPieChart;
